import { apiFetch } from '../api-client';

export interface Department {
  id: string;
  name: string;
  parentId?: string | null;
}

export const departmentsApi = {
  list: () => apiFetch<{ provider: 'erp-base'; items: Department[] }>('/api/departments'),
};
